module.exports = __webpack_public_path__ + "assets/img/returnBtn-db0f8ed1.png";